import { Injectable } from '@angular/core';
import { CookieService } from '@core/services/util/cookie.service';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    storage: any;
    localStorageKeys: Array<string> = ['latitude', 'longitude', 'outlet_locality'];

    constructor(private cookieService: CookieService) {}

    get(key: string): any {
        return this.cookieService.get(key);
    }

    set(key: string, value: string, expires?: number | Date) {
        this.cookieService.set(key, value, expires);
    }

    delete(key: string) {
        this.cookieService.remove(key);
    }
}
